<div (click)="showEvent()" class="event-container flex flex-start-center flex-full">
  <div class="event-date flex flex-col md:flex-row">
    <div
      class="event-day typography-header font-bold flex flex-col flex-center-center"
      data-test-id="event-box-element-startDate-day"
    >
      {{ event.StartDate | defaultDate: 'two_digits_day' }}
    </div>
    <div class="event-date-details flex flex-col flex-stretch-center md:flex-stretch-start">
      <span class="event-month typography-small-paragraph font-bold" data-test-id="event-box-element-startDate-month">
        {{ event.StartDate | defaultDate: 'short_month' }}
      </span>
      <span
        class="event-day-of-week typography-small-paragraph hidden md:inline"
        data-test-id="event-box-element-startDate-weekDay"
      >
        {{ event.StartDate | defaultDate: 'short_day_of_week' }}
      </span>
    </div>
  </div>
  <div class="event-details flex flex-col grow shrink-0 basis-auto">
    <span class="event-title" data-test-id="event-box-element-title">{{ event.Title | truncate: 55 }}</span>
    <span class="event-location" data-test-id="event-box-element-location" title="{{ event.Location }}">
      {{ event.Location }}
    </span>
  </div>
</div>
